import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { FlowState } from '@platform-frontend/checkout';
import { CheckoutEnvironment } from '@platform-frontend/checkout-drop-in';
import { ProductIdentifier } from '@platform-frontend/marketplace';
import { RedirectAnchorInterceptorService, deepEqual } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { HostService } from './host.service';

@Injectable({
  providedIn: 'root'
})
export class UrlBasedRedirectAnchorInterceptorService {
  constructor(private hostService: HostService, private redirectAnchorInterceptorService: RedirectAnchorInterceptorService, private store: Store) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hostUrl: string = this.hostService.getHostUrl();
    const flowProductIdentifier: ProductIdentifier | null = this.store.selectSnapshot(FlowState.productIdentifier);
    const flowVendorId: string | null = this.store.selectSnapshot(FlowState.vendorId);
    const registeredProductsForAssetStatus: ProductIdentifier<CheckoutEnvironment>[] = this.hostService.getRegisteredProductsForAssetStatus();
    const registeredVendorForCheckoutSession: string | null = this.hostService.getRegisteredVendorForCheckoutSession();

    const anchorValues: string[] = [hostUrl.split(/[#?]/, 1)[0], this.store.selectSnapshot(FlowState.flowType)];

    const registeredProductsForAnchorValues: ProductIdentifier[] = [];
    if (flowProductIdentifier) {
      registeredProductsForAnchorValues.push(flowProductIdentifier);
    }
    registeredProductsForAssetStatus.forEach(productIdentifier => {
      if (!deepEqual(flowProductIdentifier, productIdentifier)) {
        registeredProductsForAnchorValues.push(productIdentifier);
      }
    });
    anchorValues.push(JSON.stringify(registeredProductsForAnchorValues));

    if (flowVendorId) {
      anchorValues.push(flowVendorId);
    } else if (registeredVendorForCheckoutSession) {
      anchorValues.push(registeredVendorForCheckoutSession);
    }

    return this.redirectAnchorInterceptorService.intercept(request, next, 'url', anchorValues);
  }
}
